import { AiOutlineComment } from "react-icons/ai";
import { FormCategories } from "../../../../routes/type";
import { ProfileSections, SettingsTabs } from "./types";
import * as Icons from "@heroicons/react/24/solid";
import { IoDocuments } from "react-icons/io5";

export interface ProfileLeftSideBarDataProps {
  label: string;
  url: string;
  icon: JSX.Element;
  onClick?: () => void;
  textColor?: string;
  subLink?: ProfileLeftSideBarDataProps[];
  isNew?: boolean;
}

export const leftSideBarData = (
  isBusiness: boolean
  // isSubscriptionMode: boolean
) => {
  const individualProfile = [
    {
      label: "Dashboard",
      url: `?active=${ProfileSections.dashboard}`,
      icon: <Icons.RectangleGroupIcon className="h-8" />,
    },
    {
      label: "Applications",
      url: `?active=${ProfileSections.applications}`,
      icon: <Icons.DocumentTextIcon className="h-8" />,
    },
    {
      label: "Manage Case",
      url: `?active=${ProfileSections.cases}`,
      icon: <Icons.BanknotesIcon className="h-8" />,
    },
    {
      label: "FiBi AI",
      url: ``,
      icon: <AiOutlineComment size={24} />,
      isNew: true,
      subLink: [
        {
          label: "Home",
          url: `?active=${ProfileSections.fibiAi}`,
          icon: <></>,
        },
        {
          label: "My Sessions",
          url: `?active=${ProfileSections.fibiAiSessions}`,
          icon: <></>,
        },
      ],
    },
    {
      label: "Upload Documents",
      url: `?active=${ProfileSections.documents}`,
      icon: <IoDocuments className="h-8" />,
    },
    {
      label: "Settings",
      url: `?active=${ProfileSections.settings}`,
      icon: <Icons.Cog6ToothIcon className="h-8" />,
    },
  ];

  const businessProfile = [
    {
      label: "Dashboard",
      url: `?active=${ProfileSections.dashboard}`,
      icon: <Icons.RectangleGroupIcon className="h-8" />,
    },
    {
      label: "Case Management",
      url: `?active=${ProfileSections.caseManagement}`,
      icon: <Icons.DocumentTextIcon className="h-8" />,
    },
    {
      label: "FiBi AI",
      url: ``,
      icon: <AiOutlineComment size={24} />,
      isNew: true,
      subLink: [
        {
          label: "Clients",
          url: `?active=${ProfileSections.users}`,
          icon: <></>,
        },
        {
          label: "Manage Billing",
          url: `?active=${ProfileSections.billing}`,
          icon: <></>,
        },
      ],
    },
    {
      label: "Staff Management",
      url: `?active=${ProfileSections.staffManagement}`,
      icon: <Icons.UserGroupIcon className="h-8" />,
    },
    {
      label: "Settings",
      url: `?active=${ProfileSections.settings}`,
      icon: <Icons.Cog6ToothIcon className="h-8" />,
    },
    // {
    //   label: "Logout",
    //   url: ``,
    //   icon: <HiOutlineLogout className="h-8" />,
    // },
  ];

  return isBusiness ? businessProfile : individualProfile;
};

export const getAllLabels = (pages: ProfileLeftSideBarDataProps[]) => {
  return pages.map((page) => page.label);
};

type Role = {
  [key: string]: string[];
};
const roles: Role = {
  admin: getAllLabels(leftSideBarData(true)),
  staff: getAllLabels(leftSideBarData(true)).filter(
    (ev) => ev !== "Staff Management" && ev !== "Manage Billing"
  ),
};

type RolesType = "admin" | "staff" | undefined;

export const filterPagesByRole = (
  pages: ProfileLeftSideBarDataProps[],
  role: RolesType
) => {
  if (role === undefined) {
    return [];
  }
  return pages.filter((page) => {
    return roles[role]?.includes(page.label) ?? false;
  });
};

export interface NavItemsProps {
  label: string;
  url?: string;
  children?: {
    name: JSX.Element;
    url: string;
  }[];
}

export const NavItems: NavItemsProps[] = [
  {
    label: "My Account",
    children: [
      {
        name: <div>Settings</div>,
        url: `?active=${ProfileSections.settings}`,
      },
      {
        name: <div>Sign Out</div>,
        url: "",
      },
    ],
  },
];

export const settingsTab = (isBusinessData: boolean) => {
  const temp = [
    {
      title: "Profile Settings",
      url: SettingsTabs.setting,
    },
    {
      title: "Password",
      url: SettingsTabs.password,
    },
  ];

  if (!isBusinessData) {
    temp.push({
      title: "Referral",
      url: SettingsTabs.referral,
    });
  }

  return temp;
};

export const newApplicationData = [
  // {
  //   value: FormCategories.n400,
  //   label: "N-400 Citizenship through Naturalization",
  // },
  // {
  //   value: FormCategories.n565,
  //   label: "N-565 Replacement of Citizenship Document",
  // },
  // { value: FormCategories.n600, label: "N-600 Certficate of Citizenship" },
  { value: FormCategories.ds160, label: "Student Visa (F1 & M1)" },
  { value: FormCategories.ds160, label: "Travel Visa (B1/B2)" },
  { value: FormCategories.ds160, label: "Dependent Visa (F2)" },
];

export enum FibiUsersBillingType {
  token = "userWeekly",
  full = "full",
}

export const FibiUsersBillingData = [
  {
    id: FibiUsersBillingType.token,
    title: "Pay As You Go",
    // title: "Tokenized Pricing",
    subText:
      "Perfect for individuals who need quick, focused interview preparation",
    price: 5000,
    dollarPrice: 5,
    unit: "weekly",
    features: [
      "10 Interview Simulations",
      "Real-Time Feedback on answers",
      "Personalized Assessments",
      "Practice History Storage For 1 Months",
      "Download Interview Transcripts",
      "Access to a curated list of  common U.S. visa interview questions",
    ],
    buttonText: "Subscribe",
    paystackPlan: process.env.REACT_APP_PAYSTACK_FIBI_USERS,
  },
  // {
  //   id: FibiUsersBillingType.full,
  //   title: "All Access Pack",
  //   subText:
  //     "Perfect for individuals who need fully focused interview preparation",
  //   price: 20000,
  //   dollarPrice: 20,
  //   unit: "for a 30-day period",
  //   features: [
  //     "15 Interview Simulations",
  //     "DS-160 Upload",
  //     "Personalized Interview Simulation",
  //     "Feedback Assessment",
  //     "Download Interview Simulations",
  //   ],
  //   buttonText: "Subscribe",
  // },
];
